import { useCallback, useEffect, useState } from "react";
import { useBloqueioAdministrativo } from "../../hooks/useBloqueioAdministrativo";
import { ListarItens } from "./containers/lista";
import { LoadingScreen } from "components/LoadingScreen";
import { FiltroItensBloqueioAdministrativo } from "./containers/filtro";
import { IFiltroItensBloqueioAdministrativo } from "../../interfaces/IFiltroItensBloqueioAdministrativo";
import { toastAtencao, toastErro, toastSucesso } from "components/Toast";
import { IDadosCriarLote } from "../../interfaces/IDadosCriarLote";
import { IPlanilhaCriarLote } from "../../interfaces/IPlanilhaCriarLote";
import { IOptions } from "components/DropdownSelect";

interface IProps {
  setPagina: (pagina: "LOTES" | "DETALHE" | "ITENS" | "CRIAR") => void;
  dadosCriarLote: IDadosCriarLote;
  setDadosCriarLote: (dados: IDadosCriarLote) => void;
  setDadosPlanilhaCriarLote: (dados: IPlanilhaCriarLote[]) => void;
  empresasOptions: IOptions[];
  cnpjsOptions: IOptions[];
  listarCnpjsIntegracaoFrotista: (idEmpresa: number) => void;
}

export function ItensLoteBloqueioAdministrativo({
  setPagina,
  dadosCriarLote,
  setDadosCriarLote,
  setDadosPlanilhaCriarLote,
  empresasOptions,
  cnpjsOptions,
  listarCnpjsIntegracaoFrotista,
}: IProps) {
  const {
    listaItensBloqueio,
    loadingItens,
    setPageItens,
    limitItens,
    setLimitItens,
    totalRowsItens,
    listarItens,
    relatorioItens,
    itensSelecionados,
    setItensSelecionados,
    clearRowsListaItens,
    solicitacaoContraria,
  } = useBloqueioAdministrativo();

  function handlePageChange(page: number) {
    setPageItens(page);
  }
  function handleLimitChange(limit: number) {
    setLimitItens(limit);
  }

  useEffect(() => {
    listarItens();
  }, [listarItens]);

  const handleSubmit = async (dados: IFiltroItensBloqueioAdministrativo) => {
    const { data, hasErro } = await listarItens(dados);

    if (hasErro) {
      toastErro(data?.message ?? "Erro ao listar itens");
    }
  };

  const [
    showModalCertezaAcaoSelecionados,
    setShowModalCertezaAcaoSelecionados,
  ] = useState<boolean>(false);

  const [acaoSelecionada, setAcaoSelecionada] = useState<
    "bloquear" | "desbloquear"
  >("bloquear");

  const handleReverter = useCallback(async () => {
    setShowModalCertezaAcaoSelecionados(false);

    const { hasErro, data } = await solicitacaoContraria(
      itensSelecionados.map((item) => item.idItemBloqueioAdministrativo),
      acaoSelecionada,
    );

    if (hasErro) {
      toastErro(data.message ?? "Ocorreu um erro durante a solicitação");
      return;
    }

    if (!data?.itensComErro) {
      toastSucesso("Itens enviados com sucesso!");
    }

    if (data?.itensComErro && data?.totalItens) {
      if (data.itensComErro >= data.totalItens) {
        toastErro(`Erro ao enviar itens para ${acaoSelecionada}`);
      } else {
        toastAtencao("Sucesso parcial: há itens com erro");
      }
    }

    listarItens();
  }, [
    acaoSelecionada,
    itensSelecionados,
    solicitacaoContraria,
    listarItens,
    setShowModalCertezaAcaoSelecionados,
  ]);

  return (
    <>
      <LoadingScreen mostrar={loadingItens} />
      <FiltroItensBloqueioAdministrativo
        submitForm={handleSubmit}
        setRowsSelected={setItensSelecionados}
        empresasOptions={empresasOptions}
        cnpjsOptions={cnpjsOptions}
        listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
      />
      <ListarItens
        dados={listaItensBloqueio}
        handleLimitChange={handleLimitChange}
        handlePageChange={handlePageChange}
        totalRows={totalRowsItens}
        linhasPorPagina={limitItens}
        relatorioItens={relatorioItens}
        dadosCriarLote={dadosCriarLote}
        setDadosCriarLote={setDadosCriarLote}
        setDadosPlanilhaCriarLote={setDadosPlanilhaCriarLote}
        setPagina={setPagina}
        setRowsSelected={setItensSelecionados}
        selectedRows={itensSelecionados}
        clearRows={clearRowsListaItens}
        handleReverter={handleReverter}
        showModalCertezaAcaoSelecionados={showModalCertezaAcaoSelecionados}
        setShowModalCertezaAcaoSelecionados={
          setShowModalCertezaAcaoSelecionados
        }
        setAcaoSelecionada={setAcaoSelecionada}
        acaoSelecionada={acaoSelecionada}
        empresasOptions={empresasOptions}
        cnpjsOptions={cnpjsOptions}
        listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
      />
    </>
  );
}
